var render = function render(){var _vm=this,_c=_vm._self._c;return _c('air-slider-captcha',{ref:"verify",attrs:{"maxFailCount":_vm.maxFailCount,"defaultText":_vm.defaultText,"successText":_vm.successText,"failText":_vm.failText,"size":_vm.size,"bgWidth":_vm.bgWidth,"blockWidth":_vm.blockWidth,"fetchCatpcha":_vm.getCaptcha,"validator":_vm.validateCaptcha},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }